import { render, staticRenderFns } from "./vipDetail.vue?vue&type=template&id=0f8fbc45&scoped=true&"
import script from "./vipDetail.vue?vue&type=script&lang=js&"
export * from "./vipDetail.vue?vue&type=script&lang=js&"
import style0 from "./vipDetail.vue?vue&type=style&index=0&id=0f8fbc45&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8fbc45",
  null
  
)

export default component.exports